export const EnvelopeCircleIcon: React.FC = () => {
	return (
		<svg
			fill="none"
			height="55"
			viewBox="0 0 55 55"
			width="55"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="27.5" cy="27.5" fill="white" r="27.5" />
			<g clipPath="url(#clip0_379_20835)">
				<path
					d="M38.111 19.3333H17.8888C17.5057 19.3333 17.1383 19.4855 16.8674 19.7564C16.5965 20.0273 16.4443 20.3947 16.4443 20.7778V35.2222C16.4443 35.6053 16.5965 35.9727 16.8674 36.2436C17.1383 36.5145 17.5057 36.6666 17.8888 36.6666H38.111C38.4941 36.6666 38.8615 36.5145 39.1324 36.2436C39.4033 35.9727 39.5554 35.6053 39.5554 35.2222V20.7778C39.5554 20.3947 39.4033 20.0273 39.1324 19.7564C38.8615 19.4855 38.4941 19.3333 38.111 19.3333ZM36.9988 35.2222H19.0877L24.1432 29.9933L23.1032 28.9894L17.8888 34.3844V21.8755L26.866 30.8094C27.1366 31.0785 27.5027 31.2295 27.8843 31.2295C28.2659 31.2295 28.632 31.0785 28.9027 30.8094L38.111 21.6516V34.2905L32.7954 28.975L31.7771 29.9933L36.9988 35.2222ZM18.8349 20.7778H36.941L27.8843 29.7839L18.8349 20.7778Z"
					fill="black"
				/>
			</g>
			<defs>
				<clipPath id="clip0_379_20835">
					<rect
						fill="white"
						height="26"
						transform="translate(15 15)"
						width="26"
					/>
				</clipPath>
			</defs>
		</svg>
	);
};
